import { FadeIntDiv } from "../../../styledComponents/animation";
import { Link } from "react-router-dom";

const Logo = ({ open, handleClickOpen }) => {
  return (
    <>
      <div className="flex items-center mt-4">
        {open && (
          <FadeIntDiv>
            <Link to="/home">
              <img
                src="/media/image/Group 12472@2x.png"
                alt=""
                style={{ width: 190, height: 30, paddingInlineStart: 8 }}
              />
            </Link>
          </FadeIntDiv>
        )}
        {open ? (
          <img
            src="/media/image/Group 12473@2x.png"
            alt=""
            className="w-6 h-5 mb-3 transition-all rotate-0 mr-4 cursor-pointer mt-3 transi z-50"
            onClick={() => handleClickOpen()}
          />
        ) : (
          <img
            src="/media/image/Group 12473@2x.png"
            alt=""
            className="w-5 h-4 mb-5 cursor-pointer  mt-3 transition-all rotate-180 z-50"
            onClick={() => handleClickOpen()}
          />
        )}
      </div>
    </>
  );
};

export default Logo;
